import React, {MouseEventHandler} from 'react';
import {KonvaMouseEvent, SuggestionsItemProps} from "./types";

const SuggestionsItem = ({address, setAddress}: SuggestionsItemProps) => {
    const handleClick: MouseEventHandler = (e: KonvaMouseEvent) => setAddress(e.target.innerText)
    return <div className="suggestions__item" onClick={handleClick}>{address.value}</div>
}

export default SuggestionsItem
